import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  AccountResetPasswordMutation,
  AccountResetPasswordMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';

export const ACCOUNT_RESET_PASSWORD = graphql(`
  mutation AccountResetPassword($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`);

export const useResetPassword = () => {
  const [reset, { loading, error }] = useMutation<
    AccountResetPasswordMutation,
    AccountResetPasswordMutationVariables
  >(ACCOUNT_RESET_PASSWORD);

  const resetPassword = useCallback(
    async (email: string) => {
      return reset({
        variables: { email: email.toLowerCase() },
      });
    },
    [reset],
  );

  return {
    resetPassword,
    resetPasswordLoading: loading,
    resetPasswordError: error,
  };
};
